import { render, staticRenderFns } from "./Hr-docs.vue?vue&type=template&id=89c31518&"
import script from "./Hr-docs.vue?vue&type=script&lang=js&"
export * from "./Hr-docs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports